import { render } from 'preact';
import SectionHeaderAlt from 'react-components/SectionHeaderAlt';

export async function Root(element, data) {
  let { icons, classes, section_heading, section_paragraph } = data;

  function IconsGrid() {
    return (
      <div className={`${classes}`}>
        <div className="cirk-container tw-mb-[40px] tw-px-16 tw-text-center tablet:tw-px-48 desktop:tw-px-16">
          <SectionHeaderAlt
            section_heading={section_heading}
            section_paragraph={section_paragraph}
            classes={'tw-max-w-[23.75rem] tablet:tw-max-w-[36.25rem] tw-mx-auto tw-mb-[1.25rem] tablet:tw-mb-[3.5rem]'}
          />
          <div className="tw-mx-auto tw-flex tw-max-w-[330px] tw-flex-wrap tw-justify-center tw-gap-x-[27px] tw-gap-y-40 tablet:tw-max-w-[600px] desktop:tw-max-w-[820px]">
            {icons.map((icon, index) => (
              <div key={index} className="tw-flex tw-w-[calc(50%-13.5px)] tw-justify-center tablet:tw-w-[142px]">
                <img
                  src={icon.src}
                  alt={icon.alt}
                  className="tw-h-auto tw-max-w-full tw-object-contain"
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  }

  render(<IconsGrid />, element);
}
